// @ts-ignore
import fuzzy from 'fuzzyurl';
import picomatch from 'picomatch';

import { parseUrl } from './parseUrl';

/**
 * Test if a url is matching a pattern.
 */
export function isUrlMatching(urlInput: string, pattern: string): boolean {
    const parsed = parseURLPattern(pattern);
    if (!parsed) {
        return false;
    }

    // Fuzzyurl does not support proper globbing.
    // We still want to keep the legacy fuzzyurl to avoid regression for existing users.
    // For ex -> https://company.com/hello/* should ideally not match https://company.com/hello/world/again
    // but it does with fuzzyurl or it does NOT support complex patterns like https://company.com/*/hello/world/**
    // So we try use picomatch for complex patterns which is more accurate & strict
    // and fuzzyurl for legacy patterns ending with single *.
    const endsWithSingleAsterisk = parsed.pattern.at(-1) === '*' && parsed.pattern.at(-2) !== '*';
    if (endsWithSingleAsterisk && !parsed.pattern.includes('**')) {
        const mask = fuzzy.mask(parsed.pattern);
        const url = fuzzy.fromString(urlInput);

        if (!url) {
            return false;
        }

        return fuzzy.matches(mask, url);
    }

    return picomatch(parsed.pattern)(urlInput);
}

/**
 * Parse a url pattern. It returns `null` if the pattern is invalid.
 */
export function parseURLPattern(pattern: string): null | {
    pattern: string;
    domain: string;
} {
    const url = parseUrl(pattern);
    if (!url) {
        return null;
    }

    const domain = url.hostname;
    if (!domain) {
        return null;
    }

    const parts = domain.split('.');
    if (parts.length < 2 || parts[parts.length - 1]?.includes('*')) {
        return null;
    }

    return {
        domain,
        pattern,
    };
}

/**
 * Convert a domain into a set of matchin domain patterns.
 * Ex: 'www.google.com' -> ['*.google.com', 'www.google.com']
 */
export function getDomainPatterns(domain: string): string[] {
    const parts = domain.split('.');
    const patterns: string[] = [];

    for (let i = 0; i < parts.length - 2; i++) {
        patterns.push(`*.${parts.slice(i + 1).join('.')}`);
    }

    patterns.push(domain);

    return patterns;
}
